import user from './user';
import errors from './errors';
import { combineReducers } from 'redux'; //eslint-disable-line
export default combineReducers({
  user,
  errors,
});
